import { createStyles } from '@material-ui/core/styles'

import type { Theme } from '@material-ui/core/styles'

export const loadingStyles = (_theme: Theme) =>
  createStyles({
    busy: {
      paddingTop: 50,
      paddingBottom: 50,
      textAlign: 'center',
    },
  })
